import { QurealViewer } from "qureal-editor";
import React, { Fragment, Suspense } from "react";
import GenerationLoading from "../qmade/creator/GenerationLoading";
import NewGenerationLoading from "../qmade/creator/NewGenerationLoading";

// const QurealShowNative = React.lazy(() => import("../show/QurealView"));
const QurealShowNative = React.lazy(
    () => import("../showwrapper/QurealShowNativeView"),
);

function QurealOneViewer(props) {
    let is_show = process.env.REACT_APP_SHOW === "true";
    // is_show = false;

    const updated_props = {
        ...props,
        onStatusUpdate: (data) => {
            if (props.setStatus) {
                props?.setStatus(data);
            }
        },
    };

    return (
        <Fragment>
            {is_show ? (
                <Suspense fallback={<NewGenerationLoading />}>
                    <QurealShowNative
                        {...updated_props}
                        loading_view={<NewGenerationLoading />}
                    />
                </Suspense>
            ) : (
                <QurealViewer {...updated_props} />
            )}
        </Fragment>
    );
}

export default QurealOneViewer;
